import { render, staticRenderFns } from "./BaseArrow.vue?vue&type=template&id=66b722eb&scoped=true&"
import script from "./BaseArrow.vue?vue&type=script&lang=js&"
export * from "./BaseArrow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArrow.vue?vue&type=style&index=0&id=66b722eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b722eb",
  null
  
)

export default component.exports